import {
  ClockRewindIcon,
  EyeIcon,
  FileAttachment04Icon,
  Send01Icon,
  Settings01Icon,
  FolderIcon,
  Copy02Icon,
  ArchiveIcon,
  Trash01Icon,
  Upload01Icon,
  RefreshCcw02Icon,
  ClockIcon,
  BarChart10Icon,
  PauseCircleIcon,
  PlayCircleIcon,
  Share07Icon,
  Announcement02Icon,
} from '@gohighlevel/ghl-icons/24/outline'
import { renderIcon } from '@gohighlevel/ghl-ui'
import i18n from '../locales'

export const TEMPLATE_BUILDER_CONTEXT_MENU_IDs = {
  TEST_EMAIL: 'test_email',
  PREVIEW_CAMPAIGN: 'preview_campaign',
  SEE_VERSION_HISTORY: 'see_version_history',
  SAVE_TEMPLATE_SETTINGS: 'save_template_settings',
  FILE_ATTACHMENTS: 'file_attachments',
}
export const getBuilderContextActionsMenu = (isTemplate = false) => {
  const builderContextMenu = [
    {
      name: i18n.global.t('common.testEmail'),
      description: i18n.global.t('common.testEmailHelper'),
      id: TEMPLATE_BUILDER_CONTEXT_MENU_IDs.TEST_EMAIL,
      icon: `fa:paper-plane`,
      newIcon: renderIcon(Send01Icon),
    },
    {
      name: i18n.global.t('emailTemplate.preview'),
      description: i18n.global.t('emailTemplate.previewHelper'),
      id: TEMPLATE_BUILDER_CONTEXT_MENU_IDs.PREVIEW_CAMPAIGN,
      icon: 'heroicons-outline:eye',
      newIcon: renderIcon(EyeIcon),
    },
    {
      name: i18n.global.t('common.seeVersionHistory'),
      description: '',
      id: TEMPLATE_BUILDER_CONTEXT_MENU_IDs.SEE_VERSION_HISTORY,
      icon: 'fa:history',
      newIcon: renderIcon(ClockRewindIcon),
    },
  ]
  if (isTemplate)
    builderContextMenu.push({
      name: i18n.global.t('common.settings'),
      description: i18n.global.t('emailTemplate.settingsHelper'),
      id: TEMPLATE_BUILDER_CONTEXT_MENU_IDs.SAVE_TEMPLATE_SETTINGS,
      icon: 'heroicons-outline:cog',
      newIcon: renderIcon(Settings01Icon),
    })
  else
    builderContextMenu.push({
      name: i18n.global.t('emailCampaign.fileAttachment'),
      description: i18n.global.t('emailCampaign.fileAttachmentHelper'),
      id: TEMPLATE_BUILDER_CONTEXT_MENU_IDs.FILE_ATTACHMENTS,
      icon: 'heroicons-outline:document-duplicate',
      newIcon: renderIcon(FileAttachment04Icon),
    })
  return builderContextMenu
}

export const FOLDER_CONTEXT_MENU_IDs = {
  ARCHIVE_FOLDER: 'archive_folder',
  ARCHIVE_TEMPLATE: 'archive_template',
  RENAME_FOLDER: 'rename_folder',
  SEPRATOR: 'seprator', //refer Action Menu Popover component for this ID
  REMOVE_FOLDER: 'remove_folder',
}
export const TEMPLATE_CONTEXT_MENU_IDs = {
  PREVIEW_TEMPLATE: 'preview_template',
  SHARE_TEMPLATE: 'share_template',
  MOVE_TO_FOLDER: 'move_to_folder',
  CREATE_CAMPAIGN: 'create_campaign',
  ARCHIVE_TEMPLATE: 'archive_template',
  DELETE_TEMPLATE: 'delete_template',
  CLONE_CAMPAIGN: 'clone_campaign',
  UPLOAD_TEMPLATE: 'upload-template',
}
export const CAMPAIGN_CONTEXT_MENU_IDS = {
  PAUSE_CAMPAIGN: 'pause_campaign',
  RESUME_CAMPAIGN: 'resume_campaign',
  REFRESH_CAMPAIGN: 'refresh_camapaign',
  PREVIEW_CAMPAIGN: 'preview_campaign',
  CAMPAIGN_STATISTICS: 'campaign_statistics',
  RESCHEDULE_CAMPAIGN: 'reschedule_campaign',
  UPDATE_EMAIL_CONTENT: 'update_email_content',
  ARCHIVE_CAMPAIGN: 'archive_campaign',
  DELETE_CAMPAIGN: 'delete_campaign',
  UNOPENED_RESEND: 'unopened_resend',
}
export const CONTEXT_MENU_ITEM_IDs = {
  ...FOLDER_CONTEXT_MENU_IDs,
  ...TEMPLATE_CONTEXT_MENU_IDs,
  ...CAMPAIGN_CONTEXT_MENU_IDS,
}

export const getFolderContextActions = (isTemplate = true) => {
  return [
    {
      label: i18n.global.t('emailCampaign.archive'),
      description: i18n.global.t('emailCampaign.archiveHelper'),
      key: FOLDER_CONTEXT_MENU_IDs.ARCHIVE_TEMPLATE,
      icon: renderIcon(ArchiveIcon),
    },
    {
      label: i18n.global.t('common.renameFolder'),
      description: i18n.global.t('common.renameFolder'),
      key: FOLDER_CONTEXT_MENU_IDs.RENAME_FOLDER,
      icon: renderIcon(FolderIcon),
    },
    {
      label: i18n.global.t('common.deleteFolder'),
      description: i18n.global.t(
        isTemplate
          ? 'emailTemplate.deleteFolderHelper'
          : 'emailCampaign.deleteFolderHelper'
      ),
      id: FOLDER_CONTEXT_MENU_IDs.REMOVE_FOLDER,
      key: FOLDER_CONTEXT_MENU_IDs.REMOVE_FOLDER,
      icon: renderIcon(Trash01Icon),
    },
  ]
}

export const getTemplateContextActions = () => [
  {
    label: i18n.global.t('emailTemplate.preview'),
    description: i18n.global.t('emailTemplate.previewHelper'),
    key: TEMPLATE_CONTEXT_MENU_IDs.PREVIEW_TEMPLATE,
    icon: renderIcon(EyeIcon),
  },
  {
    label: i18n.global.t('common.clone'),
    description: i18n.global.t('emailCampaign.cloneHelper'),
    key: TEMPLATE_CONTEXT_MENU_IDs.CLONE_CAMPAIGN,
    icon: renderIcon(Copy02Icon),
  },
  {
    label: i18n.global.t('common.share'),
    description: i18n.global.t('emailTemplate.shareHelper'),
    key: TEMPLATE_CONTEXT_MENU_IDs.SHARE_TEMPLATE,
    icon: renderIcon(Share07Icon),
  },
  {
    label: i18n.global.t('common.moveToFolder'),
    description: i18n.global.t('emailTemplate.moveToFolderHelper'),
    key: TEMPLATE_CONTEXT_MENU_IDs.MOVE_TO_FOLDER,
    icon: renderIcon(FolderIcon),
  },

  {
    label: i18n.global.t('common.createCampaign'),
    description: i18n.global.t('emailTemplate.createCampaignHelper'),
    key: TEMPLATE_CONTEXT_MENU_IDs.CREATE_CAMPAIGN,
    icon: renderIcon(Announcement02Icon),
  },
  {
    label: i18n.global.t('common.archive'),
    description: i18n.global.t('emailTemplate.archiveHelper'),
    key: TEMPLATE_CONTEXT_MENU_IDs.ARCHIVE_TEMPLATE,
    icon: renderIcon(ArchiveIcon),
  },
  {
    label: i18n.global.t('common.delete'),
    description: i18n.global.t('emailTemplate.deleteHelper'),
    key: TEMPLATE_CONTEXT_MENU_IDs.DELETE_TEMPLATE,
    icon: renderIcon(Trash01Icon),
  },
]

export const UPLOAD_TEMPLATE_OPTION = {
  label: i18n.global.t('emailTemplate.uploadTemplate'),
  description: i18n.global.t('emailTemplate.uploadTemplateHelper'),
  key: TEMPLATE_CONTEXT_MENU_IDs.UPLOAD_TEMPLATE,
  icon: renderIcon(Upload01Icon),
}

export const getCampaignsDynamicContextMenu = () => {
  return {
    REFRESH_CAMPAIGN_STATUS: {
      label: i18n.global.t('common.refresh'),
      description: i18n.global.t('emailCampaign.refreshStatusHelper'),
      key: CAMPAIGN_CONTEXT_MENU_IDS.REFRESH_CAMPAIGN,
      icon: renderIcon(RefreshCcw02Icon),
    },
    CAMPAIGN_PREVIEW_ACTION: {
      label: i18n.global.t('emailCampaign.preview'),
      description: i18n.global.t('emailCampaign.previewHelper'),
      key: CAMPAIGN_CONTEXT_MENU_IDS.PREVIEW_CAMPAIGN,
      icon: renderIcon(EyeIcon),
    },
    CAMPAIGN_STATISTICS_ACTIONS: {
      label: i18n.global.t('emailCampaign.statisticsMenu'),
      description: i18n.global.t('emailCampaign.statisticsMenuHelper'),
      key: CAMPAIGN_CONTEXT_MENU_IDS.CAMPAIGN_STATISTICS,
      icon: renderIcon(BarChart10Icon),
    },
    CAMPAIGN_RESCHEDULE_ACTIONS: {
      label: i18n.global.t('emailCampaign.reschedule'),
      description: i18n.global.t('emailCampaign.rescheduleHelper'),
      key: CAMPAIGN_CONTEXT_MENU_IDS.RESCHEDULE_CAMPAIGN,
      icon: renderIcon(ClockIcon),
    },
    UPDATE_EMAIL_CONTENT: {
      label: i18n.global.t('emailCampaign.updateEmailContent'),
      description: i18n.global.t('emailCampaign.updateEmailContentHelper'),
      key: CAMPAIGN_CONTEXT_MENU_IDS.UPDATE_EMAIL_CONTENT,
      icon: renderIcon(BarChart10Icon),
    },
    CAMPAIGN_PAUSE_ACTION: {
      label: i18n.global.t('common.pause'),
      description: i18n.global.t('emailCampaign.pauseHelper'),
      key: CAMPAIGN_CONTEXT_MENU_IDS.PAUSE_CAMPAIGN,
      icon: renderIcon(PauseCircleIcon),
    },
    CAMPAIGN_RESUME_ACTION: {
      label: i18n.global.t('emailCampaign.resume'),
      description: i18n.global.t('emailCampaign.resumeHelper'),
      key: CAMPAIGN_CONTEXT_MENU_IDS.RESUME_CAMPAIGN,
      icon: renderIcon(PlayCircleIcon),
    },
    CAMPAIGN_RESEND_UNOPENEND: {
      label: i18n.global.t('campaignSchedule.resendUnopenedEmail'),
      description: i18n.global.t('emailCampaign.resumeHelper'),
      key: CAMPAIGN_CONTEXT_MENU_IDS.UNOPENED_RESEND,
      icon: renderIcon(PlayCircleIcon),
    },
  }
}

export const getCampaignContextActions = () => [
  {
    label: i18n.global.t('emailCampaign.preview'),
    description: i18n.global.t('emailCampaign.previewHelper'),
    key: CAMPAIGN_CONTEXT_MENU_IDS.PREVIEW_CAMPAIGN,
    icon: renderIcon(EyeIcon),
  },
  {
    label: i18n.global.t('common.moveToFolder'),
    description: i18n.global.t('emailCampaign.moveToFolderHelper'),
    key: CONTEXT_MENU_ITEM_IDs.MOVE_TO_FOLDER,
    icon: renderIcon(FolderIcon),
  },
  {
    label: i18n.global.t('common.clone'),
    description: i18n.global.t('emailCampaign.cloneHelper'),
    key: CONTEXT_MENU_ITEM_IDs.CLONE_CAMPAIGN,
    icon: renderIcon(Copy02Icon),
  },
  {
    label: i18n.global.t('emailCampaign.archive'),
    description: i18n.global.t('emailCampaign.archiveHelper'),
    key: CAMPAIGN_CONTEXT_MENU_IDS.ARCHIVE_CAMPAIGN,
    icon: renderIcon(ArchiveIcon),
  },
  {
    label: i18n.global.t('common.delete'),
    description: i18n.global.t('emailCampaign.deleteHelper'),
    key: CAMPAIGN_CONTEXT_MENU_IDS.DELETE_CAMPAIGN,
    icon: renderIcon(Trash01Icon),
  },
]
